(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ eu_projects; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/eu-co-funded-lt.png
/* harmony default export */ var eu_co_funded_lt = ({"src":"/_next/static/media/eu-co-funded-lt.39ce78a6.png","height":919,"width":4000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUGNZoTQJUcSZ8AM5kARaIdSZ+3p8Z8AAAABnRSTlMx8M4ZC8AUQZl1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR4nGNgZGIAAWYGRlYwgwUAAJAAEXon+2EAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/eu.png
/* harmony default export */ var eu = ({"src":"/_next/static/media/eu.9a00b1ca.png","height":112,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEX////////////////1pQ5zAAAABHRSTlMsGRIJS6gmlAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAABVJREFUeJxjYGJkYGBgYGZmgDAYGAEAmwAO+veKAQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./components/facts.tsx
var facts = __webpack_require__(7568);
;// CONCATENATED MODULE: ./components/eu-projects.tsx






const EuProjects = (param)=>{
    let { emblemHref  } = param;
    const emblem = /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: eu_co_funded_lt,
        alt: "Bendrai finansuoja Europos Sąjunga",
        sizes: "(max-width: 640px) 90vw, 420px",
        className: "h-auto w-full max-w-[420px]",
        priority: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-10 space-y-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "space-y-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inline-block rounded-md border border-zinc-200 bg-white p-3 dark:border-zinc-700",
                        children: emblemHref ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: emblemHref,
                            className: "block no-underline",
                            "aria-label": "Apie ES bendrai finansuojamą projektą",
                            children: emblem
                        }) : emblem
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "pt-4 text-xl font-medium tracking-tight md:text-2xl",
                        children: "Išmanusis teisės asistentas, veikiantis pagal pažangius kalbos modelius"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "MB „Pirmas kodas“ pradėjo įgyvendinti projektą „Išmanusis teisės asistentas, veikiantis pagal pažangius kalbos modelius“."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "2022–2030 m. plėtros programos valdytoja LR Švietimo, mokslo ir sporto ministerija. Finansavimo šaltinis – ES fondų lėšos ir bendrojo finansavimo lėšos."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(facts/* default */.Z, {
                        items: [
                            {
                                label: "Projekto biudžetas",
                                value: "119 032.15 Eur"
                            },
                            {
                                label: "Projekto veiklų vykdymo pradžia",
                                value: "2026 m. rugsėjis"
                            },
                            {
                                label: "Projekto veiklų vykdymo pabaiga",
                                value: "2027 m. lapkritis"
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Projekto dėka, rinkai bus pateikiamas išmanusis teisės asistentas „Teise.ai“, veikiantis pagal pažangius kalbos modelius. Vartotojas turės galimybę patirti natūralų bendravimą lietuvių kalba ir gauti pagalbą įvairiems teisės klausimams spręsti. Produktas yra inovatyvus, nes tai kol kas vienintelis dirbtinio intelekto įrankis Lietuvoje, skirtas suteikti konsultacijas, susijusias su įvairiais teisės klausimais."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-medium",
                        children: "Projektas bendrai finansuojamas Europos Sąjungos lėšomis"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "space-y-5 border-t border-zinc-200 pt-16 dark:border-zinc-800",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: eu,
                        alt: "Co-funded by the European Union",
                        className: "h-auto w-64 invert dark:invert-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "pt-4 text-xl font-medium tracking-tight md:text-2xl",
                        children: "Unified document and communication language model and an intelligent medical language model for healthcare documents development"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "UAB Taikomasis dirbtinis intelektas has launched the project „Development of a unified document and communication language model and an intelligent medical language model for healthcare documents“ No 02-020-K-0013. The project is funded by the European Regional Development Fund."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(facts/* default */.Z, {
                        items: [
                            {
                                label: "Project partner",
                                value: "MB Pirmas kodas"
                            },
                            {
                                label: "Project budget",
                                value: "€ 1 486 827, financing by EU funds up to € 1 107 546"
                            },
                            {
                                label: "Duration",
                                value: "June 10, 2024 – June 10, 2026"
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The project aims to develop a unified language model for documentation and communication and an intelligent medical language model for healthcare documents. The developed smart language model will focus on identifying potential business gaps and suggesting improvements. In addition, the system will predict the company's financial performance based on the content of the analysed documentation."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The uniqueness of this model lies in its ability to retrospectively analyse past projects and generate adapted plans for future situations. This will enable the company to allocate human and financial resources more efficiently. The model will be integrated with the company's existing systems and adapted to comply with sector-specific regulations and rules, ensuring ethically and legally sustainable solutions."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The project will contribute to the development of new high value-added products, allowing researchers to participate in the company's research and experimental development activities, promoting early pilot production of the new product developed and market readiness activities."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var eu_projects = (EuProjects);


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

/** Label/value rows separated by hairlines, for project and company details. */ const Facts = (param)=>/*#__PURE__*/ {
    let { items  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
        className: "my-8 divide-y divide-zinc-200 border-y border-zinc-200 dark:divide-zinc-800 dark:border-zinc-800",
        children: items.map((fact)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid gap-1 py-3 sm:grid-cols-[13rem_1fr] sm:gap-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                        className: "text-sm text-zinc-500",
                        children: fact.label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                        className: "text-black dark:text-white",
                        children: fact.value
                    })
                ]
            }, fact.label))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Facts);


/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_eu_projects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(638);




const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    address: {
        "@type": "PostalAddress",
        addressLocality: "Kaunas, Lithuania",
        postalCode: "LT-50423",
        streetAddress: "Birželio 23-iosios 8"
    },
    email: "info@pirmaskodas.lt",
    legalName: "MB Pirmas kodas",
    name: "Pirmas kodas",
    telephone: "+37064139571",
    url: "https://pirmaskodas.lt/",
    sameAs: [
        "https://rekvizitai.vz.lt/imone/pirmas_kodas/",
        "https://geltoni.lt/imones/pirmas-kodas-mb/327992",
        "https://kontaktai24.lt/imone/mb-pirmas-kodas/",
        "https://okredo.com/lt-lt/imone/mb-pirmas-kodas-306129624",
        "https://pirmas-kodas.vizitinekortele.lt/",
        "https://www.tax.lt/imones/84367-pirmas-projektas-mb"
    ],
    founder: {
        "@type": "Person",
        name: "Aidis Stukas",
        sameAs: [
            "https://www.aidisstukas.com/",
            "https://github.com/aidiss",
            "https://www.linkedin.com/in/aidis-stukas-2895b68/",
            "https://twitter.com/aidis_stukas",
            "https://stackoverflow.com/users/2631229/aidis"
        ]
    }
};
const description = "MB „Pirmas kodas“ įgyvendina Europos Sąjungos bendrai finansuojamą projektą: išmanusis teisės asistentas „Teise.ai“, veikiantis pagal pažangius kalbos modelius.";
const Home = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "Pirmas kodas",
                description: description,
                canonical: "https://pirmaskodas.lt",
                openGraph: {
                    url: "https://pirmaskodas.lt",
                    title: "Pirmas kodas",
                    description,
                    images: [
                        {
                            url: "https://pirmaskodas.lt/main.png",
                            width: 1200,
                            height: 628,
                            alt: "Pirmas kodas",
                            type: "image/png"
                        }
                    ],
                    site_name: "Pirmas kodas"
                },
                twitter: {
                    handle: "@pirmaskodas",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "schema-organization",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(structuredData)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl font-medium tracking-tight md:text-4xl",
                        children: "ES projektai"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_eu_projects__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        emblemHref: "/es-projektai"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,675,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);